import { useMemo } from "react";

// const useGetRecommendedRangeWidth = (
//   recommendedIdv: number,
//   maxIdv: number
// ) => {
//   return useMemo(() => {
//     if (!recommendedIdv || !maxIdv || recommendedIdv > maxIdv) {
//       return "40%"; // fallback default
//     }

//     const range = maxIdv - recommendedIdv;
//     const totalRange = maxIdv - 0; // Assuming the slider starts from 0

//     if (totalRange === 0) return "40%";

//     const widthPercentage = (range / totalRange) * 100;
//     return `${widthPercentage.toFixed(2)}%`;
//   }, [recommendedIdv, maxIdv]);
// };

const useGetRecommendedRangeWidth = (minIdv: number, maxIdv: number) => {
  if (!minIdv || !maxIdv) return "40%";

  // value to find is 80% of max IDV
  const value = 0.8 * maxIdv;

  const widthOfRecommendedRangeBrace = useMemo(() => {
    if (value <= minIdv) {
      // using default logic
      return "40%";
    }

    const diffrenceInIDVSlider = maxIdv - minIdv;
    const positionFromMaxIDV = maxIdv - value;
    // calculating the width percentage of the recommended range :)
    const widthPercentage = (positionFromMaxIDV / diffrenceInIDVSlider) * 100;

    return `${widthPercentage?.toFixed(2)}%`;
  }, [minIdv, maxIdv, value]);

  return widthOfRecommendedRangeBrace;
};

export default useGetRecommendedRangeWidth;
